import { appConfig } from "@quest/appConfig";

export const getClientIdFromSubdomain = () => {
  // const hostname = window.location.hostname; // e.g., "client-id.subdomain.com"
  const hostname =
    appConfig.environment === "development"
      ? `${appConfig.developmentSubDomain}`
      : window.location.hostname;
  const parts = hostname.split(".");
  return parts[0];
};
